import { render, staticRenderFns } from "./WaitingValuesMobile.vue?vue&type=template&id=6f67d522&scoped=true&"
import script from "./WaitingValuesMobile.vue?vue&type=script&lang=js&"
export * from "./WaitingValuesMobile.vue?vue&type=script&lang=js&"
import style0 from "./WaitingValuesMobile.vue?vue&type=style&index=0&id=6f67d522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f67d522",
  null
  
)

export default component.exports